import RedirectToTab from "features/RedirectToTab";
import { CANDIDACIES, CandidateServicePath } from "utils/constants";

// The candidacy lists are rendered as tabs by CandidatesPage. The per-type list routes stay
// registered so every "back to list" redirect keeps working — they bounce to the matching tab.
const RedirectToCandidacyTab = ({ type }) => (
  <RedirectToTab
    to={`${CandidateServicePath}${CANDIDACIES}`}
    tabKey={type}
  />
);

export default RedirectToCandidacyTab;
